module.exports = __webpack_public_path__ + "img/80412046.da0324fa.png";